import React from 'react';
import { Toast, Badge } from 'react-bootstrap';
import './notification.css';

const Notification = ({ notifications, setNotifications }) => {
  function closeNotification(id) {
    const updatedNotifications = [...notifications].filter(
      (notification) => notification.id !== id
    );
    setNotifications(updatedNotifications);
  }

  function getBadge(type) {
    if (type === 'info') {
      return (
        <>
          <Badge bg="primary">Information</Badge>
          &nbsp;&nbsp;
        </>
      );
    }
    if (type === 'success') {
      return (
        <>
          <Badge bg="success">Success</Badge>
          &nbsp;&nbsp;
        </>
      );
    }
    if (type === 'error') {
      return (
        <>
          <Badge bg="danger">Error</Badge>
          &nbsp;&nbsp;
        </>
      );
    }
    return <></>;
  }

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: 'fixed',
        minHeight: '200px',
        top: '1rem',
        right: '1rem',
        zIndex: '3000',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          minWidth: '300px',
        }}
      >
        {notifications.map((toast) => (
          <Toast
            key={toast.id}
            onClose={() => closeNotification(toast.id)}
            delay={toast.delayInSeconds * 1000}
            autohide={toast.delayInSeconds > 0}
          >
            <Toast.Header>
              {getBadge(toast.type)}
              <strong className="mr-auto">{toast.header}</strong>
            </Toast.Header>
            <Toast.Body>{toast.body}</Toast.Body>
          </Toast>
        ))}
      </div>
    </div>
  );
};

export default Notification;
